function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M720.5-79.617C1053-153.5 1356.11-25.275 1433-22v869c-116.5 97-583.5 200.5-798.5 45.5-253.884-183.033-293.5-107.5-456-184-230.033-108.292-266-379.5 62-458.5 430.874-103.777 243.818-277.136 480-329.617z",
  fill: "#fff"
});

function SvgBgRightWhiteLiquid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 873,
    height: 972,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODczIiBoZWlnaHQ9Ijk3MiIgdmlld0JveD0iMCAwIDg3MyA5NzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoCiAgICBkPSJNNzIwLjUgLTc5LjYxNjlDMTA1MyAtMTUzLjUgMTM1Ni4xMSAtMjUuMjc1NCAxNDMzIC0yMi4wMDAxVjg0N0MxMzE2LjUgOTQ0IDg0OS41IDEwNDcuNSA2MzQuNSA4OTIuNUMzODAuNjE2IDcwOS40NjcgMzQxIDc4NSAxNzguNSA3MDguNUMtNTEuNTMzIDYwMC4yMDggLTg3LjUgMzI5IDI0MC41IDI1MEM2NzEuMzc0IDE0Ni4yMjMgNDg0LjMxOCAtMjcuMTM2MSA3MjAuNSAtNzkuNjE2OVoiCiAgICBmaWxsPSJ3aGl0ZSIKICAvPgo8L3N2Zz4K";
export { SvgBgRightWhiteLiquid as ReactComponent };